import { Injectable } from '@angular/core';
import { safeLocalStorage } from '../safe-storage';

@Injectable()
export class ListViewService {


  private readonly _orderListType = 'ORDER_LIST_TYPE';

  private readonly _subContractor = 'SUB_CONTRACTOR';

  private readonly _trainNumber = 'TRAIN_NUMBER';

  private readonly _operatorIds = 'OPERATOR_IDS';

  private _pageSize: string;

  set orderListType(orderType: number) {
    safeLocalStorage.setItem(this._orderListType, JSON.stringify(orderType));
  }

  get orderListType(): number {
    const orderListType = safeLocalStorage.getItem(this._orderListType);
    if (orderListType && orderListType !== 'undefined' && orderListType !== '') {
      return JSON.parse(orderListType);
    } else {
      return 1;
    }
  }

  set subContractor(subContractor: string) {
    safeLocalStorage.setItem(this._subContractor, JSON.stringify(subContractor));
  }

  get subContractor(): string {
    const subContractor = safeLocalStorage.getItem(this._subContractor);
    if (subContractor && subContractor !== 'undefined' && subContractor !== '') {
      return JSON.parse(subContractor);
    } else {
      return '';
    }
  }

  set trainNumber(trainNumber: string) {
    safeLocalStorage.setItem(this._trainNumber, trainNumber);
  }

  get trainNumber(): string {
    const trainNumber = safeLocalStorage.getItem(this._trainNumber);
    if (trainNumber && trainNumber !== 'undefined' && trainNumber !== '') {
      return trainNumber;
    } else {
      return '';
    }
  }

  set operatorIds(operators: number[]) {
    safeLocalStorage.setItem(this._operatorIds, JSON.stringify(operators));
  }

  get operatorIds(): number[] {
    const operatorIds = safeLocalStorage.getItem(this._operatorIds);
    if (operatorIds && operatorIds !== 'undefined' && operatorIds !== '') {
      return JSON.parse(operatorIds);
    } else {
      return [];
    }
  }

  set pageSize(pageSize: number) {
    this._pageSize = JSON.stringify(pageSize);
  }

  get pageSize(): number {
    return this._pageSize && this._pageSize !== 'undefined' && this._pageSize !== '' ? JSON.parse(this._pageSize) : 10;
  }

  clearUserPerferenceSession() {
    safeLocalStorage.removeItem('_orderListType');
    safeLocalStorage.removeItem('_subContractor');
    safeLocalStorage.removeItem('_trainNumber');
    safeLocalStorage.removeItem('_operatorIds');
    safeLocalStorage.removeItem('_pageSize');
  }
}
